import React from 'react';
import { useField } from 'react-final-form';
import { styled } from '@linaria/react';
import PropTypes from 'prop-types';

import { ERROR_POLICY_EMPTY } from '../../constants';
import { Checkbox, Link } from '../../ui';
import { composeValidators } from '../../utils';
import { isError, required } from '../../utils/validators';

const isRequired = required(ERROR_POLICY_EMPTY);

const GdprOAuth2Label = styled.label`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

const GdprOAuth2Text = styled.span`
  color: ${({ meta }) =>
    isError(meta) ? 'var(--bb-error-color)' : 'var(--bb-field-color)'} !important;

  &:hover {
    cursor: pointer;
  }

  & a {
    color: ${({ meta }) =>
      isError(meta) ? 'var(--bb-error-color)' : 'var(--bb-link-color)'} !important;
    text-decoration: ${({ meta }) => (isError(meta) ? 'underline' : 'none')};
  }

  & a:hover {
    text-decoration: ${({ meta }) => (isError(meta) ? 'none' : 'underline')};
  }
`;

const Gdpr = ({
  termsLink = '/terms-and-conditions.html',
  termsLabel = 'Terms & Conditions',
  policyLink = '/privacy-policy.html',
  policyLabel = 'Privacy Policy',
}) => {
  const { input: policyInput, meta: policyMeta } = useField('policy_agree', {
    validate: composeValidators(isRequired),
    type: 'checkbox',
  });

  const { input: marketingInput, meta: marketingMeta } = useField('marketing_agree', {
    type: 'checkbox',
  });

  return (
    <>
      <GdprOAuth2Label>
        <Checkbox
          {...policyInput}
          meta={policyMeta}
        />
        <GdprOAuth2Text meta={policyMeta}>
          I agree to the{' '}
          <Link
            href={termsLink}
            target="_blank"
          >
            {termsLabel}
          </Link>{' '}
          and{' '}
          <Link
            href={policyLink}
            target="_blank"
          >
            {policyLabel}
          </Link>
          .
        </GdprOAuth2Text>
      </GdprOAuth2Label>

      <GdprOAuth2Label>
        <Checkbox
          {...marketingInput}
          meta={marketingMeta}
        />
        <GdprOAuth2Text meta={marketingMeta}>
          I agree to receive bonuses, discounts and promotional materials.
        </GdprOAuth2Text>
      </GdprOAuth2Label>
    </>
  );
};

Gdpr.propTypes = {
  termsLink: PropTypes.string,
  termsLabel: PropTypes.string,
  policyLink: PropTypes.string,
  policyLabel: PropTypes.string,
};

export default Gdpr;
